import { render } from "./ViewContrat.vue?vue&type=template&id=366e05f8&ts=true"
import script from "./ViewContrat.vue?vue&type=script&lang=ts"
export * from "./ViewContrat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__